import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  OnDestroy
} from '@angular/core';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable, Subscription, of } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  switchMap,
  startWith,
  first
} from 'rxjs/operators';
import { Router } from '@angular/router';
import { Locality } from 'src/app/core/models';
import { FilterService } from 'src/app/core/services/filter.service';
@Component({
  selector: 'app-estimer-bien',
  templateUrl: './estimer-bien.component.html',
  styleUrls: ['./estimer-bien.component.scss']
})
export class EstimerBienComponent implements OnInit, OnDestroy {
  searchForm!: FormGroup;
  inputStream$: Subscription = new Subscription;
  searchedAddresses: Locality[] = [];
  inputChange$!: Observable<string>;
  choosedLocality?: Locality | null;
  actionFromChoosedLocality?: boolean = false;
  submitted = false;
  @ViewChild('locality') locality!: ElementRef<HTMLElement>;

  constructor(
    private filterService: FilterService,
    private formBuilder: FormBuilder,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.createSearchForm();
    this.beginSearch()
  }
  createSearchForm() {
    this.searchForm = this.formBuilder.group({
      locality: ['', Validators.required],
    });
  }
  // convenience getter for easy access to form fields
  get f() { return this.searchForm.controls; }


  beginSearch(): void {
    if (this.searchForm) {
      this.inputChange$ = this.searchForm.controls.locality.valueChanges
      this.searchedAddresses = [];
      this.inputStream$ = this.inputChange$
        .pipe(
          map((e: string) => e),
          debounceTime(400),
          distinctUntilChanged(),
          startWith(''),
        )
        .subscribe(c => {
          if (!this.actionFromChoosedLocality) {
            this.choosedLocality = null;
            if (this.searchForm.controls.locality.value) {
              this.filterService.searchBackendLocalities(this.searchForm.controls.locality.value, '/google').pipe(first()).subscribe((response:any) => {
                this.searchedAddresses = response.data;
              });
            } else {
              this.searchedAddresses = [];
            }
          } else {
            this.actionFromChoosedLocality = false;
          }

        });
    }

  }

  chooseLocality(item: Locality) {
    this.actionFromChoosedLocality = true
    this.choosedLocality = item;
    this.searchForm.patchValue({
      locality: this.textLocality(item)
    });
    this.searchedAddresses = [];
  }

  textLocality(item: Locality) {
    let localityText = item.ville
    return localityText;
  }

  cancelSearchingAddress() {
    this.searchedAddresses = [];
  }

  submitFormSearch() {
    this.submitted = true;
    if (!this.choosedLocality) {
      this.searchForm.patchValue({
        locality: ''
      });
    }
    // stop here if form is invalid
    if (this.searchForm.invalid) {
      return;
    }
  }

  ngOnDestroy(): void {
    this.inputStream$.unsubscribe();
  }
}
